import type { ReactNode } from 'react'
import { MessageOutlined, TagOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_METHODS, type IdentificationMethod, type ZoneOptions } from '@/features/portal/api'
import { StepHeader } from '@/shared/ui/StepHeader'

const METHOD_ICON: Record<IdentificationMethod, ReactNode> = {
  SMS_OTP: <MessageOutlined />,
  VOUCHER: <TagOutlined />,
  ROOM_PMS: null,
  SOCIAL: null,
  STAFF_MANUAL: null,
  DEVICE_MEMO: null,
}

interface EntryStepProps {
  zone: ZoneOptions
  onSelect: (method: IdentificationMethod) => void
  onAccount: () => void
}

/**
 * Kirish ekrani — ob'ekt nomi `PortalShell` da (yuqorida), bu yerda faqat
 * "qanday kirasiz" tanlovi. Ro'yxat backend `allowedMethods` dan keladi
 * — QATTIQ YOZILMAGAN — lekin ekran faqat portal QURGAN ikkita usulni
 * ko'rsatadi (`SUPPORTED_METHODS` izohiga qarang: `ROOM_PMS`/`SOCIAL`/
 * `STAFF_MANUAL` uchun bu vazifada ekran so'ralmagan).
 */
export function EntryStep({ zone, onSelect, onAccount }: EntryStepProps) {
  const { t } = useTranslation()
  const available = SUPPORTED_METHODS.filter((method) => zone.allowedMethods.includes(method))

  if (available.length === 0) {
    return (
      <Flex vertical gap={8} align="center" style={{ textAlign: 'center', padding: '12px 0' }}>
        <Typography.Text>{t('entry.noMethods')}</Typography.Text>
      </Flex>
    )
  }

  return (
    <Flex vertical gap={18}>
      <StepHeader title={t('entry.title', { venueName: zone.venueName })} subtitle={t('entry.subtitle')} />
      <Flex vertical gap={10}>
        {available.map((method, index) => (
          <Button
            key={method}
            size="large"
            block
            type={index === 0 ? 'primary' : 'default'}
            icon={METHOD_ICON[method]}
            onClick={() => onSelect(method)}
          >
            {t(`entry.methods.${method}`)}
          </Button>
        ))}
        {available.includes('VOUCHER') ? (
          <Button size="large" block type="text" icon={<UserOutlined />} onClick={onAccount}>
            {t('entry.account')}
          </Button>
        ) : null}
      </Flex>
    </Flex>
  )
}
